'use strict';
var _ = require('lodash');
var Backbone = require('backbone');
var template = require('../../templates/document.ejs');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-document',
    events: {
        'click .nav-back': 'navBack'
    },
    /**
     * Initialize Document View
     */
    initialize: function (options) {
        _.bindAll( this, 'render', 'onLanguageChange' );

        this.copyCms = options.copyCms;
        this.type = options.type;

        this.updateDocumentModel();
        this.listenTo( this.copyCms, 'change:language', this.onLanguageChange );

    },

    updateDocumentModel: function() {
        const wid = _.getQueryParamByName('doc_wid') || this.copyCms.get('text')['views_vote_grid'][this.type]['wid'];
        const title = this.copyCms.get('text')['views_vote_grid'][this.type]['text'];
        let attributes = {
            wid: wid,
            title: title
        };

        
        this.model.set(attributes);
    },

    onLanguageChange: function() {
        this.updateDocumentModel();
        this.render();
    },

    /**
     * Render FAQ View
     */
    render: function () {
        var widgetHash = this.model.get('wid');

        this.$el.html(template({
            documentUrl: `https://docs.interactnow.tv/${widgetHash}`,
            title: this.model.get('title'),
        }));


        return this;
    },
    /**
     * [navBack description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    navBack: function (e) {
        e.preventDefault();

        window.history.back();
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/document.js